import { useMutation, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { contactFormApi, ContactFormSubmission, ContactFormResponse } from '../lib/contact-form-api';
import { QUERY_KEYS, QUERY_CONFIG } from '../constants/queryKeys';

export const useContactForm = () => {
  const queryClient = useQueryClient();
  
  return useMutation<ContactFormResponse, Error, ContactFormSubmission>(
    [QUERY_KEYS.CONTACT_FORM_SUBMISSION],
    async (data: ContactFormSubmission) => {
      return await contactFormApi.submitContactForm(data);
    },
    {
      onSuccess: (response) => {
        if (response.success) {
          toast.success(response.message || 'Thank you! We\'ll be in touch soon.');
        } else {
          toast.error(response.message || 'Something went wrong. Please try again.');
        }
      },
      onError: (error: any) => {
        console.error('Contact form submission error:', error);
        toast.error(
          error?.response?.data?.message || 
          error?.message || 
          'Failed to submit form. Please try again.'
        );
      },
    }
  );
};

export type { ContactFormSubmission, ContactFormResponse };
